document.addEventListener('DOMContentLoaded', () => {
    Fancybox.bind('[data-fancybox]', {
        Carousel: {
            transition: 'slide'
        }
    });
});